// extracted by mini-css-extract-plugin
export default {"uploadButton":"UploadFiles_uploadButton_L5AOH"};